export const fr = {
  no: 'Non',
  yes: 'Oui',
  total: 'Total',
  userNotFound: 'Utilisateur non trouvé',
  invalidCredentials: 'Identification invalide',
  badOldPassword: 'Ancien mot de passe erroné',
  somethingWentWrong: "Quelque chose s'est mal passé",
  sww: "Quelque chose s'est mal passé",
  tooReqError: 'Trop de demandes, réessayez plus tard',
  fieldRequired: 'Champ obligatoire',
  invalidEmail: 'Email invalide',
  passwordTooShort: 'Le mot de passe doit contenir au moins {0} caractères',
  login: 'Login',
  signIn: 'Se connecter',
  email: 'Email',
  password: 'Mot de passe',
  dashboard: 'Panneau de commande',
  users: 'Utilisateurs',
  customers: 'Clients',
  managers: 'Gestionnaires',
  totalDevices: "Nombre total d'installations",
  onlineDevices: 'Installations en ligne',
  devicesOnAlarm: 'Installations en alarme',
  deviceStatus: 'Statut des installations',
  search: 'Chercher',
  mac: 'MAC',
  model: 'Modèle',
  registrationNumber: 'Numéro de série',
  alarms: 'Alarmes',
  warnings: 'Alertes',
  status: 'Statut',
  lastConnection: 'Dernière connexion',
  details: 'Détails',
  summary: 'Résumé',
  viewAll: 'Voir tout',
  customersList: 'Liste de clients',
  managerList: 'Liste de gestionnaires',
  id: 'ID',
  nameSurname: 'Nom et prénom',
  city: 'Ville',
  role: 'Fonction',
  notAuthorized: 'Pas autorisé',
  confirm: 'Confirmer',
  disconnectQuestion: 'Se déconnecter ?',
  logout: 'Déconnexion',
  menu: 'Menu',
  online: 'connecté',
  offline: 'déconnecté',
  actives: 'Actifs',
  user: 'Utilisateur',
  admin: 'Administrateur',
  technician: 'Technicien',
  alarmsHistory: 'Historique des alarmes',
  date: 'Date',
  dates: 'Dates',
  name: 'nom',
  type: 'type',
  alarm: 'Alarme',
  warning: 'Alerte',
  forgetPasswordQuestion: 'Mot de passe oublié ?',
  signUp: 'Incrivez-vous !',
  registration: 'Inscription',
  attention: 'Attention',
  ok: 'OK',
  acceptDataPrivacyAgreementWarn: 'Vous devez consentir au traitement des données',
  acceptDataMarketingAgreementWarn:
    "Sélectionnez une option pour l'utilisation de vos données à des fins de marketing",
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  repeatPassword: 'Retaper le mot de passe',
  telephone: 'Téléphone',
  nation: 'Pays',
  company: 'Plate-forme',
  dataAgreement:
    'En cochant la case, vous acceptez les conditions de traitement des données personnelles conformément à la directive européenne 679/2016 et vous déclarez être majeur',
  agree: "J'accepte",
  notAgree: "Je n'accepte pas",
  marketingAgreement:
    'En cochant la case, vous acceptez que STEIEL utilise vos données personnelles à des fins de marketing',
  privacyTreatment: 'Traitement des données personnelles',
  verifyEmail: "Vérification de l'e-mail",
  emailSentToYourEmail: 'Nous avons envoyé un e-mail de vérification à :',
  emailNotReceivedQuestion: "Vous n'avez pas reçu l'e-mail ?",
  sendAgain: 'Soumettre à nouveau',
  verificationEmailSent: 'E-mail de vérification envoyé',
  lostPasswordQuestion: 'Avez-vous oublié votre mot de passe ?',
  lostPasswordInstructions:
    'Entrez votre adresse e-mail et nous vous enverrons des instructions pour configurer un nouveau mot de passe',
  resetPassword: 'Réinitialiser le mot de passe',
  goBack: 'Retourner',
  emailSentToYourAddress: 'Nous avons envoyé un e-mail à votre adresse',
  passwordChanged: 'Mot de passe changé',
  notice: 'Alerte',
  changePassword: 'Changer le mot de passe',
  settings: 'Réglages',
  add: 'Ajouter',
  profile: 'Profil',
  security: 'Sécurité',
  saveChanges: 'Sauvegarder les modifications',
  profileSavedSuccessfully: 'Profil enregistré avec succès',
  dataSavedSuccessfully: 'Données enregistrées avec succès',
  oldPassword: 'Ancien mot de passe',
  passwordChangedSuccessfully: 'Mot de passe changé avec succès',
  counterResettedSuccessfully: 'Compteur réinitialisé avec succès',
  at: 'à',
  noDataFound: 'Aucune donnée disponible',
  deviceManagement: 'Gestion des installations',
  modulesManagement: 'Liste des appareils',
  moduleName: 'Module',
  installationName: 'Installation',
  usersManagement: 'Gestion des utilisateurs',
  version: 'Version',
  dateAndTime: 'Date/Heure',
  place: 'Lieu',
  comeback: 'Retourner',
  setup: 'Configuration',
  default: 'Default',
  interface: 'Interface',
  temperature: 'Température',
  ph: 'pH',
  chlorine: 'Chlore',
  totalChlorine: 'Chlore total',
  freeChlorine: 'Chlore libre',
  combinedChlorine: 'Chlore combiné',
  table: 'Tableau',
  charts: 'Graphiques',
  setpoint: 'Setpoint',
  customizeMeasurements: 'Personnaliser le layout',
  active: 'Actif',
  deactivated: 'Pas actif',
  minAcceptableValue: 'Limite min acceptable',
  maxAcceptableValue: 'Limite max acceptable',
  outputs: 'Sorties',
  inputs: 'Entrées',
  on: 'on',
  off: 'off',
  value: 'Valeur',
  exportTable: 'Exporter tableau',
  exportAlarms: 'Exporter alarmes',
  localDateTime: 'Date/Heure (locale)',
  notes: 'Remarques',
  channel: 'Canal',
  description: 'Description',
  deviceDetails: "Détails de l'installation",
  measure: 'Mesure',
  enable: 'Autoriser',
  unitOfMeasure: 'Unité de mesure',
  scaleStart: "Début d'échelle",
  bottomScale: "Fin d'échelle",
  minAlarm: 'Alarme min',
  maxAlarm: 'Alarme max',
  minAcceptableLimit: 'Limite min acceptable',
  maxAcceptableLimit: 'Limite max acceptable',
  decimals: 'Décimales',
  selectWidget: 'Sélectionner Widget',
  notifications: 'Avis',
  notificationsDelay: 'Délai des avis (minutes)',
  recipientList: 'Liste des destinataires',
  customizeNotification: 'Personnaliser les avis',
  apply: 'Appliquer',
  view: 'Voir',
  searchPlaceholder: 'Chercher ID, nom, lieu',
  filter: 'Filtre',
  withAlarm: 'Alarme',
  notWithAlarm: "Pas d'alarme",
  cancel: 'Annuler',
  close: 'Fermer',
  deviceDefaultSettingsResetQuestion:
    "Voulez-vous réinitialiser l'installation aux paramètres d'usine ?",
  samplingTime: "Temps d'échantillonnage (min)",
  timeZone: 'Décalage horaire',
  macAddress: 'Adresse MAC',
  tool: 'Instrument',
  newCustomer: 'Nouveau utilisateur',
  newManager: 'Nouveau gestionnaire',
  locality: 'Lieu',
  notificationManagement: 'Gestion des avis',
  manageNotifications: 'Gérer les avis',
  sendEmail: 'Envoyer un e-mail',
  usersList: 'Liste des utilisateurs',
  modifyCustomer: 'Modifier utilisateur',
  modifyManager: 'Modifier gestionnaire',
  newUser: 'Nouveau utilisateur',
  deleteUser: "Supprimer l'utilisateur",
  notePlaceholder: 'Insérer une note',
  insertLogo: 'Insérer le logo',
  language: 'Langue',
  file: 'File',
  create: 'Créer',
  modify: 'Modifier',
  update: 'Mettre à jour',
  createNewCustomer: 'Créer un nouveau utilisateur',
  createNewManager: 'Créer un nouveau gestionnaire',
  viewer: 'Observateur',
  superTechnician: 'Partenaire',
  supertechnician: 'Partenaire',
  newDevice: 'Nouvelle installation',
  createNewDevice: 'Créer une nouvelle installation',
  installer: 'Partenaire',
  newModule: 'Nouveau module',
  modules: 'Modules',
  numberOfDevices: 'N° Dispositifs',
  modifyDevice: 'Modifier installation',
  goToDevicePage: 'Aller à État Installation',
  searchByNamePlace: 'Chercher prénom, lieu',
  searchByNameSurnameUsername: "Chercher prénom, nom, nom d'utilisateur...",
  surname: 'Nom',
  username: "Nom d'utilisateur",
  modifyUser: 'Modifier utilisateur',
  confirmPassword: 'Confirmer le mot de passe',
  insertNote: 'Insérer une note',
  createNewUser: 'Créer un nouveau utilisateur',
  customersManagement: 'Gestion des utilisateurs',
  customer: 'Utilisateur',
  manager: 'Gestionnaire',
  send: 'Envoyer',
  modifyPassword: 'Modifier le mot de passe',
  newPassword: 'Nouveau mot de passe',
  passwordRecoveryInstructions:
    'Entrez votre email, nous vous enverrons un lien pour changer votre mot de passe',
  userProfile: 'Profil utilisateur',
  italian: 'Italien',
  english: 'Anglais',
  currentPassword: 'Mot de passe actuel',
  new: 'Nouveau',
  deviceInterfaceChartTitle: 'SwimEx Cold Plunge Pool',
  deviceInterfaceChartMobileTip:
    "Orientez l'appareil horizontalement pour une meilleure vue du graphique",
  deviceInterfaceChartTip: 'Placez le pointeur sur le graphique pour afficher les données',
  dtBodyNoMatch: 'Aucune donnée disponible',
  dtBodyTooltip: 'Trier',
  dtBodyColumnHeaderTooltip: 'Trier par',
  dtNextPage: 'Page suivante',
  dtPreviousPage: 'Page précédente',
  dtRowsPerPage: 'Lignes par page :',
  jumpToPage: 'Passer à la page :',
  dtDisplayRows: 'de',
  dtToolbarSearch: 'Chercher',
  dtToolbarDownloadCsv: 'Télécharger CSV',
  dtToolbarPrint: 'Imprimer',
  dtToolbarViewColumns: 'Vieu de colonnes',
  dtToolbarFilterTable: 'Filtrer le tableau',
  dtFilterAll: 'Tout',
  dtFilterTitle: 'Filtres',
  dtFilterReset: 'Réinitialiser',
  dtViewColumnsTitle: 'Afficher les colonnes',
  dtViewColumnsTitleAria: 'Afficher/masquer les colonnes',
  dtSelectedRowsText: 'Lignes sélectionnées',
  dtSelectedRowsDelete: 'Supprimer',
  dtSelectedRowsDeleteAria: 'Supprimer les lignes sélectionnées',
  success: 'Réussi',
  recoveryPasswordEmailSent: 'E-mail de récupération de mot de passe envoyé',
  french: 'Français',
  noInterfaceConnected: 'Aucune interface connectée',
  hthInterfaceName: 'CYCL’EAU First',
  hthProInterfaceName: 'CYCL’EAU Pro',
  input_pHLvl: 'Niveau pH',
  input_cl2Lvl: 'Niveau chlore',
  input_lvl3: 'Niveau 3',
  input_flow: 'Flow',
  input_cadOff: 'CAD (Off)',
  output_out1: 'Out 1',
  output_out2: 'Out 2',
  output_alarm: 'Relais alarme',
  alarm_lowPHLvl: 'Niveau pH bas',
  alarm_lowCl2Lvl: 'Niveau chlore bas',
  alarm_flow: 'Flow',
  alarm_onOffKey: 'Touche ON/OFF',
  alarm_inputCadOff: 'Entrée CAD Off',
  alarm_maxPHDosage: 'Dosage maxi pH',
  alarm_maxCl2Dosage: 'Dosage maxi chlore',
  alarm_startDelay: 'Délai au démarrage',
  alarm_pHMin: 'pH minimum',
  alarm_phMax: 'pH maximum',
  alarm_cl2Min: 'Cl minimum',
  alarm_cl2Max: 'Cl maximum',
  alarm_autoClean: 'Autonettoyant',
  noMeasurementFound: 'Aucune mesure disponible',
  settingsSavedSuccessfully: 'Paramètres enregistrés avec succès',
  parameters: 'Paramètres',
  parameter: 'Paramètre',
  noParametersFound: 'Aucun paramètre disponible',
  setpointPHParamDesc: 'Seuil inject. 1 (OUT_pH)',
  setpointCl2ParamDesc: 'Seuil inject. 2 (OUT_Cl)',
  minPHAlarmParamDesc: 'Alarme (alerte) min. pH',
  maxPHAlarmParamDesc: 'Alarme (alerte) max. pH',
  minFreeChlorineParamDesc: 'Alarme (alerte) min. chlore',
  maxFreeChlorineParamDesc: 'Alarme (alerte) max. chlore',
  maxCombChlorineParamDesc: 'Alarme (alerte) max. chlore combiné',
  settingTypePHParamDesc: 'Type de réglage OUT_pH',
  settingTypeCl2ParamDesc: 'Type de réglage OUT_Cl',
  hysteresisPHParamDesc: 'Hystérèse OUT_pH',
  hysteresisCl2ParamDesc: 'Hystérèse OUT_Cl',
  sensePHParamDesc: 'Sens pH',
  startDelayParamDesc: 'Délai au démarrage (sec)',
  flowDelayParamDesc: 'Délai après rétablissement du débit (sec)',
  maxInjectionTimeParamDesc: "Temps d'injection max. (min)",
  pHTankLvlParamDesc: 'Niveau bac pH',
  chlorineTankLvlParamDesc: 'Niveau bac chlore',
  flowSensorParamDesc: 'Capteur de débit',
  totalChlorineParamDesc: 'Chlore total',
  languageParamDesc: 'Langue',
  alarmRelayParamDesc: 'Relais alarme',
  serialLineParamDesc: 'Ligne série',
  serialLineCommSpeedParamDesc: 'Vitesse de communication de la ligne série',
  modbusCommAddrParamDesc: 'Adresse de communication Modbus',
  passwordParamDesc: 'Mot de passe',
  proportional: 'Proportionnel',
  onOff: 'On-Off',
  alkaline: 'Alcalin',
  acid: 'Acide',
  spanish: 'Espagnol',
  ascii: 'Ascii',
  modbus: 'Modbus',
  min: 'min.',
  max: 'max.',
  onlineWithAlarm: 'En ligne avec alarme',
  macAddressNotFound: 'Adresse MAC non trouvé',
  deviceFormModulesIncomplete:
    'Pour chaque module, renseignez MAC, nom, instrument et version (valeurs valides, non vides)',
  invalidCompanyValue: 'Valeur plate-forme non valide',
  deleteDevice: "Supprimer l'installation",
  deleteDeviceQuestion: "Supprimer l'installation ?",
  userCreatedSuccessfully: 'Utilisateur créé avec succès',
  deleteUserQuestion: "Supprimer l'utilisateur {0} ?",
  deviceCreatedSuccessfully: 'Installation créée avec succès',
  noMeasurementsFoundOrEnabled: 'Aucune mesure activée ou trouvée',
  companyDomain: 'Domaine de plate-forme',
  from: 'de',
  to: 'à',
  alarmsFixed: 'Alarmes résolues',
  badInputData: "Données d'entrée incorrectes",
  changesCompleted: 'Modifications terminées',
  upload: 'Charger',
  invalidFileSize: 'Taille de fichier non valide',
  invalidFileType: 'Type de fichier non valide',
  alarm_maxTimeK1: 'Temps maxi K1',
  alarm_maxTimeK2: 'Temps maxi K2',
  alarm_maxTimeK4: 'Temps maxi K4',
  alarm_maxTimeK5: 'Temps maxi K5',
  alarm_ignitionDelay: 'Délai au démarrage',
  alarm_pHStabilizer: 'Stabilization du pH',
  alarm_clock: 'Horloge',
  alarm_zeroChlorine: 'Zéro chlore',
  alarm_redox: 'Redox',
  alarm_superchlorination: 'Superchloration',
  alarm_notUsed1: 'Non utilisé 1',
  alarm_notUsed2: 'Non utilisé 2',
  alarm_notUsed3: 'Non utilisé 3',
  alarm_notUsed4: 'Non utilisé 4',
  alarm_richAssist: "Demande d'assistance",
  alarm_toolBlock: "Bloc de l'appareil",
  output_k1: 'K1',
  output_k2: 'K2',
  output_k3: 'K3',
  output_k4: 'K4',
  output_k5: 'K5',
  output_ev: 'EV',
  output_perist1: 'Périst1',
  output_perist2: 'Périst2',
  output_perist3: 'Périst3',
  output_mixer: 'Mixer 1',
  input_lvl1: 'Niveau 1',
  input_lvl2: 'Niveau 2',
  input_off: 'Entrée OFF',
  input_imp: 'Entrée IMP',
  P01MC14ParamDesc: 'Mesure associée à la sortie relais K1',
  P02MC14ParamDesc: 'Type de sortie relais K1',
  P03MC14ParamDesc: '',
  P04MC14ParamDesc: '',
  P05MC14ParamDesc: '',
  P06MC14ParamDesc: '',
  P07MC14ParamDesc: 'Alarme max temps de dosage relais K1 (h : min)',
  P08MC14ParamDesc: 'Conditions OFF relais K1',
  P09MC14ParamDesc: 'Mesure associée à la sortie relais K2',
  P10MC14ParamDesc: 'Type de sortie relais K2',
  P11MC14ParamDesc: '',
  P12MC14ParamDesc: '',
  P13MC14ParamDesc: '',
  P14MC14ParamDesc: '',
  P15MC14ParamDesc: 'Alarme max temps de dosage relais K2 (h : min)',
  P16MC14ParamDesc: 'Conditions OFF relais K2',
  P17MC14ParamDesc: '',
  P18MC14ParamDesc: '',
  P19MC14ParamDesc: '',
  P20MC14ParamDesc: '',
  P21MC14ParamDesc: '',
  P22MC14ParamDesc: '',
  P23MC14ParamDesc: '',
  P24MC14ParamDesc: '',
  P25MC14ParamDesc: '',
  P26MC14ParamDesc: '',
  P27MC14ParamDesc: '',
  P28MC14ParamDesc: '',
  P29MC14ParamDesc: '',
  P30MC14ParamDesc: '',
  P31MC14ParamDesc: '',
  P32MC14ParamDesc: '',
  P33MC14ParamDesc: '',
  P34MC14ParamDesc: '',
  P35MC14ParamDesc: '',
  P36MC14ParamDesc: '',
  P37MC14ParamDesc: '',
  P38MC14ParamDesc: '',
  P39MC14ParamDesc: '',
  P40MC14ParamDesc: '',
  P41MC14ParamDesc: '',
  P42MC14ParamDesc: '',
  P43MC14ParamDesc: '',
  P44MC14ParamDesc: '',
  P45MC14ParamDesc: '',
  P46MC14ParamDesc: '',
  P47MC14ParamDesc: '',
  P48MC14ParamDesc: '',
  P49MC14ParamDesc: '',
  P50MC14ParamDesc: '',
  P51MC14ParamDesc: '',
  P52MC14ParamDesc: '',
  P53MC14ParamDesc: '',
  P54MC14ParamDesc: '',
  P55MC14ParamDesc: '',
  P56MC14ParamDesc: '',
  P57MC14ParamDesc: '',
  P58MC14ParamDesc: '',
  P59MC14ParamDesc: '',
  P60MC14ParamDesc: '',
  P61MC14ParamDesc: '',
  P62MC14ParamDesc: '',
  P63MC14ParamDesc: '',
  P64MC14ParamDesc: '',
  P65MC14ParamDesc: '',
  P66MC14ParamDesc: '',
  P67MC14ParamDesc: '',
  P68MC14ParamDesc: '',
  P69MC14ParamDesc: '',
  P70MC14ParamDesc: '',
  P71MC14ParamDesc: '',
  P72MC14ParamDesc: '',
  P73MC14ParamDesc: '',
  P74MC14ParamDesc: '',
  P75MC14ParamDesc: '',
  P76MC14ParamDesc: '',
  P77MC14ParamDesc: '',
  P78MC14ParamDesc: '',
  P79MC14ParamDesc: '',
  P80MC14ParamDesc: '',
  P81MC14ParamDesc: '',
  P82MC14ParamDesc: '',
  P83MC14ParamDesc: '',
  P84MC14ParamDesc: '',
  P85MC14ParamDesc: '',
  P86MC14ParamDesc: '',
  P87MC14ParamDesc: '',
  P88MC14ParamDesc: '',
  P89MC14ParamDesc: '',
  P90MC14ParamDesc: '',
  P91MC14ParamDesc: '',
  P92MC14ParamDesc: '',
  P93MC14ParamDesc: '',
  P94MC14ParamDesc: '',
  notAvailable: 'Pas disponible',
  disabled: 'Désactivée',
  closingOverthresholds: 'Fermeture au dépassement de seuils',
  openingOverthreshold: 'Ouverture au dépassement de seuils',
  upward: 'En montée',
  downward: 'En déscente',
  hourlyOperation: 'Fonctionnement horaire',
  unknown: 'Inconnu',
  mc14evoPHRxCle12TcInterfaceName: 'MC14 EVO pH/RX/CLE12/T',
  mc14evoPHRxCacTcInterfaceName: 'MC14 EVO pH/RX/CAC/T',
  mc14evo_4CanaliTcInterfaceName: 'MC14 EVO 4 canali + T',
  mco14_3SezCl2InterfaceName: 'MCO14 EVO 3 sections (Cl2)',
  mco14_5SezCl2ClTClCInterfaceName: 'MCO14 EVO 5 sections (Cl2 + ClT + ClC)',
  nsp161InterfaceName: 'NOVA NSP161',
  nsp161CMinInterfaceName: 'NOVA NSP161 c/min',
  nsp161MAInterfaceName: 'NOVA NSP161 mA',
  nsp162PHRxInterfaceName: 'NOVA NSP162 pH/RX',
  nsp163ACle11_12InterfaceName: 'NOVA NSP163A CLE11/12',
  nsp163BCle16InterfaceName: 'NOVA NSP163B CLE16',
  pHRxTcInterfaceName: 'EF315 pH/RX/T',
  pHClTcInterfaceName: 'EF315 pH/CL/T',
  pHCacTcInterfaceName: 'EF315 pH/CAC/T',
  channels: 'Canaux',
  sectionMin: 'Sections',
  loggedInAs: 'Authentifié comme',
  badRangeInput: 'Valeurs non valides',
  open: 'Ouvrir',
  all: 'Toutes',
  moduleComunicationTimeoutErrDesc: "Vérifier le câblage et l'alimentation de l'interface",
  updateParamFailed: 'Mise à jour du paramètre échoué',
  saveChangesQuestion: 'Voulez-vous vraiment enregistrer les modifications ?',
  secondaryParameters: 'Paramètres secondaires',
  P03MC14ParamDescOption1: 'Seuil à atteindre relais K1',
  P03MC14ParamDescOption2: "Valeur centrale d'alarme relais K1",
  P03MC14ParamDescOption3: 'Heure de la première activation relais K1',
  P04MC14ParamDescOption1: 'Hystérèse relais K1',
  P04MC14ParamDescOption2: 'Hystérésis au dessus et en dessous du seuil relais K1',
  P04MC14ParamDescOption3: 'Heure de la première désactivation relais K1',
  P11MC14ParamDescOption1: 'Seuil à atteindre relais K2',
  P11MC14ParamDescOption2: "Valeur centrale d'alarme relais K2",
  P11MC14ParamDescOption3: 'Heure de la première activation relais K2',
  P12MC14ParamDescOption1: 'Hystérèse relais K2',
  P12MC14ParamDescOption2: 'Hystérésis au dessus et en dessous du seuil relais K2',
  P12MC14ParamDescOption3: 'Heure de la première désactivation relais K2',
  P27MC14ParamDescOption1: 'Seuil à atteindre relais K4',
  P27MC14ParamDescOption2: "Valeur centrale d'alarme relais K4",
  P27MC14ParamDescOption3: 'Heure de la première activation relais K4',
  P28MC14ParamDescOption1: 'Hystérèse relais K4',
  P28MC14ParamDescOption2: 'Hystérésis au dessus et en dessous du seuil relais K4',
  P28MC14ParamDescOption3: 'Heure de la première désactivation relais K4',
  alarm_lvl: 'Niveau',
  alarm_extcons: 'Autorisation (Ext.Cons.)',
  alarm_stop: 'Stop',
  alarm_urOr: 'UR/OR',
  alarm_timer: 'Timer',
  alarm_maintenance: 'Entretien',
  alarm_autoadesco: 'Auto-amorçage',
  alarm_internalTemp: 'Température interne',
  alarm_maxDoseTime: 'Max temps de dosage',
  alarm_maxAccPulses: "Max d'impulsions cumulables",
  alarm_sampleWater: 'Eau échantillon',
  alarm_clockKO: 'Horloge KO',
  output_magnetStatus: "Statut de l'aimant",
  output_relayAlarm: 'Relais de statut',
  input_lvl: 'Niveau',
  input_extcons: 'Autorisation (Ext.Cons.)',
  P01NSPParamDesc: 'Langue',
  P02NSPParamDesc: '',
  P03NSPParamDesc: '',
  P04NSPParamDesc: '',
  P05NSPParamDesc: '',
  P06NSPParamDesc: '',
  P07NSPParamDesc: 'Fréquence maxi',
  P08NSPParamDesc: '',
  P09NSPParamDesc: '',
  P10NSPParamDesc: '',
  P11NSPParamDesc: 'Point consigne',
  P12NSPParamDesc: 'Hystérésis / Bande proportionnelle',
  P13NSPParamDesc: '',
  P14NSPParamDesc: '',
  P15NSPParamDesc: '',
  P16NSPParamDesc: '',
  P17NSPParamDesc: '',
  P18NSPParamDesc: '',
  P19NSPParamDesc: '',
  P20NSPParamDesc: '',
  P21NSPParamDesc: '',
  P22NSPParamDesc: '',
  P23NSPParamDesc: '',
  P24NSPParamDesc: '',
  P25NSPParamDesc: '',
  P26NSPParamDesc: '',
  P27NSPParamDesc: '',
  P28NSPParamDesc: '',
  P29NSPParamDesc: '',
  P30NSPParamDesc: '',
  P31NSPParamDesc: '',
  P32NSPParamDesc: '',
  P33NSPParamDesc: '',
  P34NSPParamDesc: '',
  P35NSPParamDesc: '',
  P36NSPParamDesc: '',
  P37NSPParamDesc: '',
  P38NSPParamDesc: '',
  P39NSPParamDesc: '',
  P40NSPParamDesc: '',
  P41NSPParamDesc: '',
  P42NSPParamDesc: '',
  P43NSPParamDesc: '',
  P44NSPParamDesc: '',
  P45NSPParamDesc: '',
  P46NSPParamDesc: '',
  P47NSPParamDesc: '',
  P48NSPParamDesc: '',
  P49NSPParamDesc: '',
  P50NSPParamDesc: '',
  P51NSPParamDesc: '',
  P52NSPParamDesc: '',
  P53NSPParamDesc: '',
  P54NSPParamDesc: '',
  P55NSPParamDesc: '',
  P56NSPParamDesc: '',
  P57NSPParamDesc: '',
  P58NSPParamDesc: '',
  P59NSPParamDesc: '',
  P60NSPParamDesc: '',
  P61NSPParamDesc: '',
  P62NSPParamDesc: '',
  P63NSPParamDesc: '',
  P64NSPParamDesc: '',
  P65NSPParamDesc: '',
  P66NSPParamDesc: '',
  P67NSPParamDesc: '',
  P68NSPParamDesc: '',
  P69NSPParamDesc: '',
  P70NSPParamDesc: '',
  P71NSPParamDesc: '',
  P72NSPParamDesc: '',
  P73NSPParamDesc: '',
  P74NSPParamDesc: '',
  P75NSPParamDesc: '',
  P76NSPParamDesc: '',
  P77NSPParamDesc: '',
  P78NSPParamDesc: '',
  P79NSPParamDesc: '',
  P80NSPParamDesc: '',
  P81NSPParamDesc: '',
  P82NSPParamDesc: '',
  P83NSPParamDesc: '',
  P84NSPParamDesc: '',
  P85NSPParamDesc: '',
  P86NSPParamDesc: '',
  P87NSPParamDesc: '',
  P88NSPParamDesc: '',
  P89NSPParamDesc: '',
  P90NSPParamDesc: '',
  P91NSPParamDesc: '',
  P92NSPParamDesc: '',
  P93NSPParamDesc: '',
  P94NSPParamDesc: '',
  P95NSPParamDesc: '',
  alarm_lvl1: 'Niveau 1',
  alarm_lvl2: 'Niveau 2',
  alarm_maxDosageTimeOut1: 'Temps de dosage max Out 1',
  alarm_maxDosageTimeOut2: 'Temps de dosage max Out 2',
  alarm_urOrMeasure1: 'UR/OR Mesure 1',
  alarm_urOrMeasure2: 'UR/OR Mesure 2',
  alarm_maintenancePump1: 'Entretien de la pompe 1',
  alarm_maintenancePump2: 'Entretien de la pompe 2',
  alarm_recalibrateChlorineProbeAfter24h: 'Recalibrer la sonde de chlore après 24 heures',
  alarm_halvedSetpointForBadCalib: 'Setpoint réduit de moitié',
  input_stop: 'Stop',
  input_ignitionDelay: 'Délai au démarrage',
  input_pHStabilizer: 'Stabilization du pH',
  input_maintenancePump1: 'Entretien de la pompe 1',
  input_maintenancePump2: 'Entretien de la pompe 2',
  input_recalibrateChlorineProbeAfter24h: 'Recalibrer la sonde de chlore après 24 heures',
  input_halvedSetpointForBadCalib: 'Point consigne réduit de moitié',
  P01EFParamDesc: '',
  P02EFParamDesc: '',
  P03EFParamDesc: 'Point consigne (Out 1)',
  P04EFParamDesc: 'Hystérésis / Bande proportionnelle (Out 1)',
  P05EFParamDesc: 'Fréquence maxi (Out 1)',
  P06EFParamDesc: '',
  P07EFParamDesc: '',
  P08EFParamDesc: '',
  P09EFParamDesc: '',
  P10EFParamDesc: 'Point consigne (Out 2)',
  P11EFParamDesc: 'Hystérésis / Bande proportionnelle (Out 2)',
  P12EFParamDesc: 'Fréquence maxi (Out 2)',
  P13EFParamDesc: '',
  P14EFParamDesc: '',
  P15EFParamDesc: '',
  P16EFParamDesc: '',
  P17EFParamDesc: '',
  P18EFParamDesc: '',
  P19EFParamDesc: '',
  P20EFParamDesc: '',
  P21EFParamDesc: '',
  P22EFParamDesc: '',
  P23EFParamDesc: '',
  P24EFParamDesc: '',
  P25EFParamDesc: '',
  P26EFParamDesc: '',
  P27EFParamDesc: '',
  P28EFParamDesc: '',
  P29EFParamDesc: '',
  P30EFParamDesc: '',
  P31EFParamDesc: '',
  P32EFParamDesc: '',
  P33EFParamDesc: '',
  P34EFParamDesc: '',
  eventsLog: 'LOG des événements',
  events: 'Événements',
  alarm_new_stop: 'Instrument OFF',
  alarm_new_inputCadOff: 'Entrée OFF',
  alarm_new_flow: 'Alarme Flow',
  alarm_new_urOr: 'Alarme UR/OR',
  alarm_new_lowPHLvl: 'Alarme Min niveau pH',
  alarm_new_lowCl2Lvl: 'Alarme Min niveau Cl',
  alarm_new_maxPHDosage: 'Alarme Max dosage pH',
  alarm_new_maxCl2Dosage: 'Alarme Max dosage Cl',
  alarm_new_pHMin: 'Alerte min pH',
  alarm_new_phMax: 'Alerte max pH',
  alarm_new_cl2Min: 'Alerte min Cl',
  alarm_new_cl2Max: 'Alerte max Cl',
  alarm_new_clock: 'Timer',
  alarm_new_maxTimeK1: 'Alarme Max T K1',
  alarm_new_maxTimeK2: 'Alarme Max T K2',
  alarm_new_maxTimeK4: 'Alarme Max T K4',
  alarm_new_maxTimeK5: 'Alarme Max T K5',
  alarm_new_redox: 'Alarme Redox',
  alarm_new_zeroChlorine: 'Alarme zéro Cl',
  output_mixer2: 'Mixer 2',
  alarm_extConsensus: 'Autorisation externe',
  alarm_lvl1MinAlarm: 'Alarme Min niveau 1',
  alarm_lvl2MinAlarm: 'Alarme Min niveau 2',
  alarm_lvl3MinAlarm: 'Alarme Min niveau 3',
  alarm_off: 'Off',
  alarm_new_maintenance: 'Entretien requis',
  alarm_new_timer: 'Alarme Timer',
  alarm_new_lvl: 'Alarme Niveau',
  alarm_new_extcons: 'Alarme Ext.Cons',
  alarm_new_internalTemp: 'Alarme température interne',
  alarm_new_clockKO: 'Alarme horloge KO',
  alarm_new_sampleWater: 'Sample Water',
  alarm_new_maxDoseTime: 'Alarme Max Dosage',
  alarm_new_maintenancePump1: 'Entretien P1',
  alarm_new_maintenancePump2: 'Entretien P2',
  alarm_new_urOrMeasure1: 'Alarme UR/OR Mesure 1',
  alarm_new_urOrMeasure2: 'Alarme UR/OR Mesure 2',
  alarm_new_lvl1: 'Alarme Niveau 1',
  alarm_new_lvl2: 'Alarme Niveau 2',
  alarm_new_maxDosageTimeOut1: 'Alarme MAX T P1',
  alarm_new_maxDosageTimeOut2: 'Alarme MAX T P2',
  statuses: 'Statuts',
  theme: 'thème',
  toolStatus: "Status de l'instrument",
  minWarningLimit: 'Valeur limite min',
  maxWarningLimit: 'Valeur limite max',
  canNotSaveOfflineOrErrModule:
    'Les paramètres ne peuvent pas être enregistrés lorsque le module est hors ligne ou en erreur de communication',
  ew2PoolInterfaceName: 'Evolution EW² Pool',
  ew2Pool_pHOrpTcInterfaceName: 'EW² Pool pH/ORP/T',
  ew2Pool_pHCacTcInterfaceName: 'EW² Pool pH/CAC/T',
  ew2Pool_pHCleTcInterfaceName: 'EW² Pool pH/CLE/T',
  nova2Pool_pHOrpTcInterfaceName: 'Nova² Pool pH/ORP/T',
  nova2Pool_pHCacTcInterfaceName: 'Nova² Pool pH/CAC/T',
  nova2Pool_pHCleTcInterfaceName: 'Nova² Pool pH/CLE/T',
  nova2PoolP_pHOrpTcInterfaceName: 'Nova² Pool P pH/ORP/T',
  nova2PoolP_pHCacTcInterfaceName: 'Nova² Pool P pH/CAC/T',
  nova2PoolP_pHCleTcInterfaceName: 'Nova² Pool P pH/CLE/T',
  alarm_minThresholdM1: 'Seuil minimum pH',
  alarm_maxThresholdM1: 'Seuil maximum pH',
  alarm_lvl1m1: 'Niveau 1 pH',
  alarm_lvl2m1: 'Niveau 2 pH',
  alarm_underRangeM1: 'Under Range pH',
  alarm_overRangeM1: 'Over Range pH',
  alarm_maxDosageM1: 'Max dosage pH',
  alarm_minThresholdM2: 'Seuil minimum Cl',
  alarm_maxThresholdM2: 'Seuil maximum Cl',
  alarm_lvl1m2: 'Niveau 1 Cl',
  alarm_lvl2m2: 'Niveau 2 Cl',
  alarm_minLimitPh: 'Limite min pH',
  alarm_maxLimitPh: 'Limite max pH',
  alarm_lvlPh: 'Niveau pH',
  alarm_minLimitCl: 'Limite min Cl',
  alarm_maxLimitCl: 'Limite max Cl',
  alarm_lvlCl: 'Niveau Cl',
  alarm_underRangeM2: 'Under Range Cl',
  alarm_overRangeM2: 'Over Range Cl',
  alarm_maxDosageM2: 'Max dosage Cl',
  alarm_sampleFlow: 'Débit eau échantillon',
  alarm_pHPriority: 'pH priority',
  output_pfmM1: 'OUT PFM pH',
  output_pfmM2: 'OUT PFM Cl',
  output_outM1: 'OUT pH',
  output_flocculant: 'OUT FLOCULANT',
  output_outM2: 'OUT Cl',
  output_antiAlgae: 'OUT ANTI-ALGUES',
  output_poolRelayAlarm: 'RELAIS ALARME',
  input_lvl1m1: 'EN Niveau 1 pH',
  input_lvl2m1: 'EN Niveau 2 pH',
  input_externalConsent: 'EN Autorisation externe',
  input_ecoMode: 'EN Eco Mode',
  input_sampleWater: 'EN Sample Water',
  input_lvl1m2: 'EN Niveau 1 Cl',
  input_lvl2m2: 'EN Niveau 2 Cl',
  setpointM1OnOffParamDesc: 'Point consigne pH On/Off',
  propBandM1OnOffParamDesc: 'Hystérèse pH On/Off',
  dosageDirM1OnOffParamDesc: 'Direction du dosage pH On/Off',
  maxDosageTimeM1OnOffParamDesc: 'Temps MAX Dosage pH On/Off',
  setpointM1PwmParamDesc: 'Point consigne pH PWM',
  propBandM1PwmParamDesc: 'Bande proportionnelle pH PWM',
  dosageDirM1PwmParamDesc: 'Direction du dosage pH PWM',
  maxDosageTimeM1PwmParamDesc: 'Temps MAX Dosage pH PWM',
  setpointM2OnOffParamDesc: 'Point consigne Cl On/Off',
  setpointM2PwmParamDesc: 'Point consigne Cl PWM',
  setpointM1PfmParamDesc: 'Point consigne pH PFM',
  propBandM1PfmParamDesc: 'Bande proportionnelle pH PFM',
  dosageDirM1PfmParamDesc: 'Direction du dosage pH PFM',
  maxDosageTimeM1PfmParamDesc: 'Temps MAX Dosage pH PFM',
  minFreqM1ParamDesc: 'Fréquence min pH',
  maxFreqM1ParamDesc: 'Fréquence max pH',
  minLimitM1ParamDesc: 'Limite MIN pH',
  maxLimitM1ParamDesc: 'Limite MAX pH',
  propBandM2OnOffParamDesc: 'Hystérèse Cl On/Off',
  dosageDirM2OnOffParamDesc: 'Direction du dosage Cl On/Off',
  maxDosageTimeM2OnOffParamDesc: 'Temps MAX Dosage Cl On/Off',
  propBandM2PwmParamDesc: 'Bande proportionnelle Cl PWM',
  dosageDirM2PwmParamDesc: 'Direction du dosage Cl PWM',
  maxDosageTimeM2PwmParamDesc: 'Temps MAX Dosage Cl PWM',
  setpointM2PfmParamDesc: 'Point consigne Cl PFM',
  propBandM2PfmParamDesc: 'Banda Proporzionale M2 PFM',
  dosageDirM2PfmParamDesc: 'Direction du dosage Cl PFM',
  maxDosageTimeM2PfmParamDesc: 'Temps MAX Dosage Cl PFM',
  minFreqM2ParamDesc: 'Fréquence min Cl',
  maxFreqM2ParamDesc: 'Fréquence max Cl',
  setpointEcoModeParamDesc: 'Point consigne Eco/Boost Mode',
  udmTempParamDesc: 'UDM Température',
  maxLimitM2ParamDesc: 'Limite MAX Cl',
  minLimitM2ParamDesc: 'Limite MIN Cl',
  acidification: 'Acidification',
  alkalization: 'Alcalinisation',
  dechlorination: 'Déchloration',
  chlorination: 'Chloration',
  output_out230VM2: 'OUT_230V Cl',
  output_out230VM1: 'OUT_230V pH',
  output_phMagnet: "Statut de l'aimant pH",
  output_clMagnet: "Statut de l'aimant Cl",
  output_phOutputStatus: 'Statut de la sortie pH',
  output_clOutputStatus: 'Statut de la sortie Cl',
  admin2: 'Distributeur',
  referent: 'Référent',
  externalConsent: 'Autorisation externe',
  ecoMode: 'Eco-Mode',
  companyName: "Nom de l'entreprise",
  invalidNameOrCompanyName: "Définir un nom/prénom ou un nom d'entreprise",
  alarm_sampleFlowM1: 'flusso campione M1',
  alarm_sampleFlowM2: 'flusso campione M2',
  output_out1M1: 'OUT1 M2', // STEIEL-161 OUT1 M1
  output_out2M1: 'OUT2 M2', // STEIEL-161 OUT2 M1
  output_out1M2: 'OUT1 M1', // STEIEL-161 OUT1 M2
  output_out2M2: 'OUT2 M1', // STEIEL-161 OUT2 M2
  output_pfm1M1: 'PFM1 M1',
  output_pfm2M1: 'PFM2 M1',
  output_pfm1M2: 'PFM1 M2',
  output_pfm2M2: 'PFM2 M2',
  input_sampleWaterM2: 'Samplewater M2',
  ew2InterfaceName: 'EW²',
  input_ew2_lvl1m1: 'Livello 1 M1',
  input_ew2_lvl2m1: 'Livello 2 M1',
  input_ew2_externalConsent: 'Abilitazione esterna',
  input_ew2_ecoMode: 'Autonettoyant',
  input_ew2_sampleWater: 'Samplewater M1',
  input_ew2_sampleWaterM2: 'Samplewater M2',
  input_ew2_lvl1m2: 'Livello 1 M2',
  input_ew2_lvl2m2: 'Livello 2 M2',
  input_waterMeter: 'Water meter',
  alarm_ew2_minThresholdM1: 'soglia minima M1',
  alarm_ew2_maxThresholdM1: 'soglia massima M1',
  alarm_ew2_lvl1m1: 'level 1 M1',
  alarm_ew2_lvl2m1: 'level 2 M1',
  alarm_ew2_underRangeM1: 'under range M1',
  alarm_ew2_overRangeM1: 'over range M1',
  alarm_ew2_maxDosageM1: 'massimo dosaggio M1',
  alarm_ew2_sampleFlowM1: 'flusso campione M1',
  alarm_ew2_minThresholdM2: 'soglia minima M2',
  alarm_ew2_maxThresholdM2: 'soglia massima M2',
  alarm_ew2_lvl1m2: 'level 1 M2',
  alarm_ew2_lvl2m2: 'level 2 M2',
  alarm_ew2_underRangeM2: 'under range M2',
  alarm_ew2_overRangeM2: 'over range M2',
  alarm_ew2_maxDosageM2: 'massimo dosaggio M2',
  alarm_ew2_sampleFlowM2: 'flusso campione M2',
  P01EW2ParamDesc: 'Config. OUT1 M1',
  P02EW2ParamDesc: 'Setpoint OUT1 OnOff M1',
  P03EW2ParamDesc: 'Setpoint OUT1 PWM M1',
  P04EW2ParamDesc: 'Int. Lavoro OUT1 Soglia1 M1',
  P05EW2ParamDesc: 'Int. Lavoro OUT1 Soglia2 M1',
  P06EW2ParamDesc: 'Config. OUT2 M1',
  P07EW2ParamDesc: 'Setpoint OUT2 OnOff M1',
  P08EW2ParamDesc: 'Setpoint OUT2 PWM M1',
  P09EW2ParamDesc: 'Int. Lavoro OUT2 Soglia1 M1',
  P10EW2ParamDesc: 'Int. Lavoro OUT2 Soglia2 M1',
  P11EW2ParamDesc: 'Config. OUT3 M1',
  P12EW2ParamDesc: 'Setpoint OUT3 PFM M1',
  P13EW2ParamDesc: 'Frequenza min OUT3 M1',
  P14EW2ParamDesc: 'Frequenza max OUT3 M1',
  P15EW2ParamDesc: 'Config. OUT4 M1',
  P16EW2ParamDesc: 'Setpoint OUT4 PFM M1',
  P17EW2ParamDesc: 'Frequenza min OUT4 M1',
  P18EW2ParamDesc: 'Frequenza max OUT4 M1',
  P19EW2ParamDesc: 'Config. OUT-mA M1',
  P20aEW2ParamDesc: 'Scala OUT-mA M1',
  P20bEW2ParamDesc: 'Scala OUT-mA M1',
  P21EW2ParamDesc: 'Setpoint OUT-mA M1 (Reg.)',
  P22EW2ParamDesc: 'Limite min M1 ',
  P23EW2ParamDesc: 'Limite max M1 ',
  P24EW2ParamDesc: 'Setpoint Eco/Boost mode OUT1 M1',
  P25EW2ParamDesc: 'Setpoint Eco/Boost mode OUT2 M1',
  P26EW2ParamDesc: 'Setpoint Eco/Boost mode OUT-mA M1',
  P27EW2ParamDesc: 'Config. OUT1 M2',
  P28EW2ParamDesc: 'Setpoint OUT1 OnOff M2',
  P29EW2ParamDesc: 'Setpoint OUT1 PWM M2',
  P30EW2ParamDesc: 'Int. Lavoro OUT1 Soglia1 M2',
  P31EW2ParamDesc: 'Int. Lavoro OUT1 Soglia2 M2',
  P32EW2ParamDesc: 'Config. OUT2 M2',
  P33EW2ParamDesc: 'Setpoint OUT2 OnOff M2',
  P34EW2ParamDesc: 'Setpoint OUT2 PWM M2',
  P35EW2ParamDesc: 'Int. Lavoro OUT2 Soglia1 M2',
  P36EW2ParamDesc: 'Int. Lavoro OUT2 Soglia2 M2',
  P37EW2ParamDesc: 'Config. OUT3 M2',
  P38EW2ParamDesc: 'Setpoint OUT3 PFM M2',
  P39EW2ParamDesc: 'Frequenza min OUT3 M2',
  P40EW2ParamDesc: 'Frequenza max OUT3 M2',
  P41EW2ParamDesc: 'Config. OUT4 M2',
  P42EW2ParamDesc: 'Setpoint OUT4 PFM M2',
  P43EW2ParamDesc: 'Frequenza min OUT4 M2',
  P44EW2ParamDesc: 'Frequenza max OUT4 M2',
  P45EW2ParamDesc: 'Config. OUT-mA M2',
  P46aEW2ParamDesc: 'Scala OUT-mA M2',
  P46bEW2ParamDesc: 'Scala OUT-mA M2',
  P47EW2ParamDesc: 'Setpoint OUT-mA M2 (Reg.)',
  P48EW2ParamDesc: 'Limite min M2',
  P49EW2ParamDesc: 'Limite max M2',
  P50EW2ParamDesc: 'Setpoint Eco/Boost mode OUT1 M2',
  P51EW2ParamDesc: 'Setpoint Eco/Boost mode OUT2 M2',
  P52EW2ParamDesc: 'Setpoint Eco/Boost mode OUT-mA M2',
  P53EW2ParamDesc: 'Isteresi OUT1 OnOff M1',
  P54EW2ParamDesc: 'Banda Proporzionale OUT1 PWM M1',
  P55EW2ParamDesc: 'Direzione Dosaggio OUT1 OnOff M1',
  P56EW2ParamDesc: 'Direzione Dosaggio OUT1 PWM M1',
  P57EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff M1',
  P58EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 PWM M1',
  P59EW2ParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro) M1',
  P60EW2ParamDesc: 'Isteresi OUT2 OnOff M1',
  P61EW2ParamDesc: 'Banda Proporzionale OUT2 PWM M1',
  P62EW2ParamDesc: 'Direzione Dosaggio OUT2 OnOff M1',
  P63EW2ParamDesc: 'Direzione Dosaggio OUT2 PWM M1',
  P64EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff M1',
  P65EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 PWM M1',
  P66EW2ParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro) M1',
  P67EW2ParamDesc: 'Banda Proporzionale OUT3 PFM M1',
  P68EW2ParamDesc: 'Direzione Dosaggio OUT3 PFM M1',
  P69EW2ParamDesc: 'Tempo MAX Dosaggio OUT3 PFM M1',
  P70EW2ParamDesc: 'Banda Proporzionale OUT4 PFM M1',
  P71EW2ParamDesc: 'Direzione Dosaggio OUT4 PFM M1',
  P72EW2ParamDesc: 'Tempo MAX Dosaggio OUT4 PFM M1',
  P73EW2ParamDesc: 'Valore 0/4 mA OUT-mA M1',
  P74EW2ParamDesc: 'Valore 20 mA OUT-mA M1',
  P75EW2ParamDesc: 'Banda Proporzionale OUT-mA M1',
  P76EW2ParamDesc: 'Direzione Dosaggio OUT-mA M1',
  P77EW2ParamDesc: 'Tempo MAX Dosaggio OUT-mA M1',
  P78EW2ParamDesc: 'Isteresi OUT1 OnOff M2',
  P79EW2ParamDesc: 'Banda Proporzionale OUT1 PWM M2',
  P80EW2ParamDesc: 'Direzione Dosaggio OUT1 OnOff M2',
  P81EW2ParamDesc: 'Direzione Dosaggio OUT1 PWM M2',
  P82EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff M2',
  P83EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 PWM M2',
  P84EW2ParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro) M2',
  P85EW2ParamDesc: 'Isteresi OUT2 OnOff M2',
  P86EW2ParamDesc: 'Banda Proporzionale OUT2 pwm M2',
  P87EW2ParamDesc: 'Direzione Dosaggio OUT2 OnOff M2',
  P88EW2ParamDesc: 'Direzione Dosaggio OUT2 PWM M2',
  P89EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff M2',
  P90EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 PWM M2',
  P91EW2ParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro) M2',
  P92EW2ParamDesc: 'Banda Proporzionale OUT3 PFM M2',
  P93EW2ParamDesc: 'Direzione Dosaggio OUT3 PFM M2',
  P94EW2ParamDesc: 'Tempo MAX Dosaggio OUT3 PFM M2',
  P95EW2ParamDesc: 'Banda Proporzionale OUT4 PFM M2',
  P96EW2ParamDesc: 'Direzione Dosaggio OUT4 PFM M2',
  P97EW2ParamDesc: 'Tempo MAX Dosaggio OUT4 PFM M2',
  P98EW2ParamDesc: 'Valore 0/4 mA OUT-mA M2',
  P99EW2ParamDesc: 'Valore 20 mA OUT-mA M2',
  P100EW2ParamDesc: 'Banda Proporzionale OUT-mA M2',
  P101EW2ParamDesc: 'Direzione Dosaggio OUT-mA M2',
  P102EW2ParamDesc: 'Tempo MAX Dosaggio OUT-mA M2',
  repetition: 'ripetizione',
  regulation: 'regulation',
  acidificationDechlorinationReduction: 'Acidificazione/Declorazione/Riduzione',
  alkalizationChlorinationOxidation: 'Alcalinizzazione/Clorazione/Ossidazione',
  workInt: 'Int. di lavoro',
  ewInterfaceName: 'EW',
  input_ew_lvl1m1: 'Livello 1 M1',
  input_ew_lvl2m1: 'Livello 2 M1',
  input_ew_externalConsent: 'Abilitazione esterna',
  input_ew_ecoMode: 'Eco/boost mode',
  input_ew_sampleWater: 'Samplewater M1',
  input_ew_autoClean: 'Autonettoyant',
  alarm_ew_minThresholdM1: 'soglia minima M1',
  alarm_ew_maxThresholdM1: 'soglia massima M1',
  alarm_ew_lvl1m1: 'level 1 M1',
  alarm_ew_lvl2m1: 'level 2 M1',
  alarm_ew_underRangeM1: 'under range M1',
  alarm_ew_overRangeM1: 'over range M1',
  alarm_ew_maxDosageM1: 'massimo dosaggio M1',
  alarm_ew_sampleFlowM1: 'flusso campione M1',
  P01EWParamDesc: 'Config. OUT1',
  P02EWParamDesc: 'Setpoint OUT1 OnOff',
  P03EWParamDesc: 'Setpoint OUT1 PWM',
  P04EWParamDesc: 'Int. Lavoro OUT1 Soglia1',
  P05EWParamDesc: 'Int. Lavoro OUT1 Soglia2',
  P06EWParamDesc: 'Config. OUT2',
  P07EWParamDesc: 'Setpoint OUT2 OnOff',
  P08EWParamDesc: 'Setpoint OUT2 PWM',
  P09EWParamDesc: 'Int. Lavoro OUT2 Soglia1',
  P10EWParamDesc: 'Int. Lavoro OUT2 Soglia2',
  P11EWParamDesc: 'Config. OUT3',
  P12EWParamDesc: 'Setpoint OUT3 PFM',
  P13EWParamDesc: 'Frequenza min OUT3',
  P14EWParamDesc: 'Frequenza max OUT3',
  P15EWParamDesc: 'Config. OUT4',
  P16EWParamDesc: 'Setpoint OUT4 PFM',
  P17EWParamDesc: 'Frequenza min OUT4',
  P18EWParamDesc: 'Frequenza max OUT4',
  P19EWParamDesc: 'Config. OUT-mA',
  P20aEWParamDesc: 'Scala OUT-mA',
  P20bEWParamDesc: 'Scala OUT-mA',
  P21EWParamDesc: 'Setpoint OUT-mA (Reg.)',
  P22EWParamDesc: 'Limite min',
  P23EWParamDesc: 'Limite max',
  P24EWParamDesc: 'Setpoint Eco/Boost mode OUT1',
  P25EWParamDesc: 'Setpoint Eco/Boost mode OUT2',
  P26EWParamDesc: 'Setpoint Eco/Boost mode OUT-mA',
  P27EWParamDesc: 'Isteresi OUT1 OnOff',
  P28EWParamDesc: 'Banda Proporzionale OUT1 PWM',
  P29EWParamDesc: 'Direzione Dosaggio OUT1 OnOff',
  P30EWParamDesc: 'Direzione Dosaggio OUT1 PWM',
  P31EWParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff',
  P32EWParamDesc: 'Tempo MAX Dosaggio OUT1 PWM',
  P33EWParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro)',
  P34EWParamDesc: 'Isteresi OUT2 OnOff',
  P35EWParamDesc: 'Banda Proporzionale OUT2 PWM',
  P36EWParamDesc: 'Direzione Dosaggio OUT2 OnOff',
  P37EWParamDesc: 'Direzione Dosaggio OUT2 PWM',
  P38EWParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff',
  P39EWParamDesc: 'Tempo MAX Dosaggio OUT2 PWM',
  P40EWParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro)',
  P41EWParamDesc: 'Banda Proporzionale OUT3 PFM',
  P42EWParamDesc: 'Direzione Dosaggio OUT3 PFM',
  P43EWParamDesc: 'Tempo MAX Dosaggio OUT3 PFM',
  P44EWParamDesc: 'Banda Proporzionale OUT4 PFM',
  P45EWParamDesc: 'Direzione Dosaggio OUT4 PFM',
  P46EWParamDesc: 'Tempo MAX Dosaggio OUT4 PFM',
  P47EWParamDesc: 'Valore 0/4 mA OUT-mA',
  P48EWParamDesc: 'Valore 20 mA OUT',
  P49EWParamDesc: 'Banda Proporzionale OUT-mA',
  P50EWParamDesc: 'Direzione Dosaggio OUT-mA',
  P51EWParamDesc: 'Tempo MAX Dosaggio OUT-mA',
  alertNumberDecimals1:
    "Attention! Le réglage du nombre de décimales doit correspondre à la résolution affichée sur l'instrument.",
  alertNumberDecimals2:
    'Il est essentiel de suivre cette indication pour éviter les dysfonctionnements du système.',
  selfCleaning: 'Autonettoyant',
  userHierarchy: 'Hiérarchie des utilisateurs',
  orgChartYou: 'Vous',
  orgChartResetView: 'Réinitialiser la vue',
  orgChartCenterOnUser: "Centrer sur l'utilisateur actuel",
  orgChartShowAll: 'Afficher tout',
  userHierarchyList: 'Hiérarchie des utilisateurs (liste)',
  hierarchyNoLinkedUsers: 'Aucun utilisateur lié.',
  hierarchyNavigateUp: 'Niveau supérieur',
  hierarchyRoleUnknown: 'Rôle non renseigné',
  instrumentName: 'nom instrument',
  P34Nova2PoolPParamDesc: 'Config. Pump pH',
  P35Nova2PoolPParamDesc: 'Config. Pump Cl',
  hthEw2PoolMachineTypeAltName: 'CYCL’EAU EW²Pool DIVERSEY',
};
